import { CreateVendorInterface } from "../interfaces/VendorInterface/CreateVendorInterface";
import { VendorInterface } from "../interfaces/VendorInterface/Vendorinterface";
import BaseService from "./BaseService";

export class VendorService extends BaseService<VendorInterface, CreateVendorInterface>{ 
    constructor(){
        let url: string = '/vendor/admin'
        super(url)
    }
}